import { FC, useMemo, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { LogShipmentItem } from './LogShipmentItem';
import { ILogShipmentsProps } from './types';

const MAX_ITEMS_TO_SHOW = 2;

export const LogShipments: FC<ILogShipmentsProps> = ({ shipmentLogs }) => {
  const [showAll, setShowAll] = useState(false);
  const logsTotal = shipmentLogs?.length ?? 0;

  const handleAddMore = () => {
    setShowAll(true);
  };

  const itemsToShow = useMemo(() => (showAll ? logsTotal : Math.min(logsTotal, MAX_ITEMS_TO_SHOW)), [logsTotal, showAll]);
  const items = useMemo(() => shipmentLogs?.slice(0, itemsToShow), [shipmentLogs, itemsToShow]);

  return (
    <div>
      {items.map((log) => (
        <LogShipmentItem key={`shipment-log-${log?.shipmentInvoiceId}`} log={log} />
      ))}
      {logsTotal > MAX_ITEMS_TO_SHOW && !showAll && (
        <div className='mt-8'>
          <button onClick={handleAddMore} className='flex items-center gap-4 text-14 font-medium text-primary'>
            <span>Show More</span>
            <KeyboardArrowDownIcon />
          </button>
        </div>
      )}
    </div>
  );
};
